<template>
  <el-dialog
    title="Vote"
    :visible.sync="isOpen"
    width="7.2rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
  >
    <div class="detail-item spaceLeft">
      <span class="detail-item-label">Proposal No :</span>
      <span>{{ rowData.id }}</span>
    </div>
    <div class="detail-item">
      <voteProgress
        :cumulative.sync="rowData.totalWeight"
        :threshold.sync="rowData.threshold"
      />
    </div>
    <div class="detail-item spaceLeft">
      <span class="detail-item-label">Vote :</span>
      <div class="balance-box">
        <el-input type='number' v-model="inputVal" @change="checkVal"
          ><template slot="append"
            ><span class="unit"
              >Balance : <big-number :number="balance"/></span></template
        ></el-input>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn
        class="common-btn-blue-sm"
        label="Submit"
        @clickHandle="save"
      />
    </span>
  </el-dialog>
</template>

<script>
import voteProgress from "@/views/governance/components/voteProgress.vue";
import { toBigNum, toBigItem } from "@/utils/bigNumberTran.js";
export default {
  data() {
    return {
      loading: false,
      isOpen: false,
      rowData: {},
      tableList: [],
      inputVal: undefined,
      balance: 0,
      threshold:undefined
    };
  },
  components: { voteProgress },
  methods: {
    open({ row, threshold }) {
      console.log(row)
      this.init();
      this.getBalance();
      this.isOpen = true;
      this.rowData = row || {};
      this.threshold = threshold;
      this.inputVal = undefined;
    },
    close() {
      this.rowData = {};
      this.inputVal = undefined;
      this.isOpen = false;
    },
    init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAdd = this.$store.getters.contractMap["contractDao"].address;

    },
    async getBalance() {
      try {
        this.balance = await web3.eth.getBalance(
          this.$store.getters.metaMaskObj.account
        );
      } catch (e) {
        console.log("getBalance--", e);
      }
    },
    checkVal() {
      // if (toBigItem(this.inputVal).comparedTo(this.balance) > 0){
      //   this.inputVal = toBigItem(this.balance)
      // }else{
      //   this.inputVal = this.inputVal
      // }
    },
    save(btn) {
      if (toBigItem(this.inputVal).comparedTo(this.balance) > 0){
        this.$message.warning("Insufficient UNIT balance");
        btn.closeLoad();
        return;
      }
      const tx_builder = this.contractDao.methods["castVote"](this.rowData.proposalId,1);
      const encoded_tx = tx_builder.encodeABI();
      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractDaoAdd,
          value: toBigNum(this.inputVal),
          data: encoded_tx
        })
        .then(res => {
          btn.closeLoad();
          this.$message.success("You have successfully voted!");
          this.$emit("success");
          this.close();
        })
        .catch(error => {
          // if(proposer)
          // this.$message.error("You have already voted, please do not vote again.");
          if(error.code === 4001){
            this.$message.error("You have rejected this transaction");
          }else{
            this.$message.error("operation failed");
          }
          console.error(error);
          btn.closeLoad();
        });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.balance-box {
  position: relative;
  flex: 1 0 0;
  /deep/ .el-input__inner {
    height: 0.48rem;
    background: #f7f8fa;
    border-color: #f7f8fa;
  }
  /deep/ .el-input-group__append {
    background: #f7f8fa;
    border-color: #f7f8fa;
    font-size: 0.18rem;
    color: #aaaaaa;
  }
}
.detail-item {
  margin-bottom: 0.35rem;
}
</style>
